import { Navigate } from 'react-router-dom';

export function AcquisitionRedirect() {
  return <Navigate to="/?service=discontinued" replace />;
}